import { useSelector } from 'react-redux';
import { emptyArray } from 'ui-components/default-props/empty';

import Globals from '../../store/global-selectors';

export const useShipFroms = () => {
  return useSelector(Globals.selectSellerShipFroms) || emptyArray;
};
